import { createRoot } from 'react-dom/client';
import './index.css';
import './premium.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';

createRoot(document.getElementById('root')).render(<App />);

// Pass a function to log page-speed numbers, for example reportWebVitals(console.log).
reportWebVitals();
